module.exports = __webpack_public_path__ + "img/3DFiles.1ea9551f.svg";